<style lang="css">

</style>

<template lang="html">

<div>
  <el-table :data="datas" style="width: 100%">

    <el-table-column prop="create_time" label="操作时间">
    </el-table-column>

    <el-table-column label="行为">
      <template scope="scope">
        <div class="">
          <span style="color:red;">{{scope.row.event=='changedPage'?'访问':'点击'}} </span> {{scope.row.describe}}
        </div>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination style="margin-top:10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
  </el-pagination>
</div>

</template>

<script>

import coinModel from '@/framework/models/coinModel'
export default {
  name: 'user-browse-record-detail',
  data: function () {
    return {
      id: null,
      pageNum: 1,
      pageSize: 10,
      datas: [],
      total: 0
    }
  },
  created: function () {
    let params = this.$route.params
    this.id = params.id
    this.loadList()
  },
  methods: {
    handleCurrentChange: function (pageNum) {
      this.pageNum = pageNum
      this.loadList()
    },
    handleSizeChange: function (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.loadList()
    },
    loadList: function () {
      let _this = this
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        lcwUserId: this.id
      }
      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.datas.data
          _this.total = dataInfo.datas.recordsTotal
        }
      }

      coinModel.findUserBrowseRecordDetail(_this, params, listener)
    }
  }
}

</script>
